import { easepick } from '@easepick/bundle';
import { TimePlugin } from '@easepick/time-plugin';
import { AmpPlugin } from '@easepick/amp-plugin';
import { LockPlugin } from '@easepick/lock-plugin';

var pickers = {};
var year = new Date().getFullYear() + 10;

$(document).ready(function() {
  make_pickers();
  $('.add-exclude-date').click(function(event) {
    remove_pickers();
    make_pickers();
  });

  $('body').on('diary-loaded', function () {
    remove_pickers();
    make_pickers();
  });

  $('#editBookingModal').on('bookingLoaded', function () {
    remove_pickers();
    make_pickers();
  });
});

function make_pickers() {
  $('input.date-picker').each(function(index, el) {
    if($(el).hasClass('inline')) {
      var inline = true;
    } else {
      var inline = false;
    }

    if($(el).attr('data-allow-past') == "true") {
      var min_date = null;
    } else {
      var min_date = new Date();
    }

    if($(el).hasClass('clear')) {
      $('<a href="#" class="clear">Clear</a>').insertAfter( el ).on('click', function(event) {
        event.preventDefault();
        pickers['picker-'+index].clear();
      });
    }
    pickers['picker-'+index] = new easepick.create({
      element: el,
      css: [
        'https://cdn.jsdelivr.net/npm/@easepick/bundle@1.2.1/dist/index.css',
        '/css/date-picker.css',
      ],
      format: 'DD/MM/YYYY',
      zIndex: 999,
      inline: inline,
      setup(picker) {
        picker.on('select', (e) => {
          $(el).trigger('change');
        });

        $(el).on('open-new-booking', function(event) {
          event.preventDefault();
          picker.setDate($(el).val());
          picker.gotoDate($(el).val())
        });
      },
      AmpPlugin: {
        dropdown: {
          months: true,
          years: true,
          maxYear: year
        }
      },
      plugins: [AmpPlugin, LockPlugin],
      LockPlugin: {
          minDate: min_date
      },
    });
    if($(el).val()) {
      pickers['picker-'+index].setDate($(el).val());
      pickers['picker-'+index].gotoDate($(el).val());
    }
  });

  $('body').find('input.date-picker-2').each(function(index, el) {
    if($(el).hasClass('inline')) {
      var inline = true;
    } else {
      var inline = false;
    }
    if($(el).hasClass('clear')) {
      $('<a href="#" class="clear">Clear</a>').insertAfter( el ).on('click', function(event) {
        event.preventDefault();
        pickers['picker-2-'+index].clear();
      });
    }
    pickers['picker-2-'+index] = new easepick.create({
      element: el,
      css: [
        'https://cdn.jsdelivr.net/npm/@easepick/bundle@1.2.1/dist/index.css',
        '/css/date-picker.css',
      ],
      format: 'DD/MM/YYYY',
      zIndex: 999,
      calendars: 2,
      grid: 2,
      inline: inline,
      autoApply: true,
      setup(picker) {
        picker.on('select', (e) => {
          $(el).trigger('change');
        });
      },
      AmpPlugin: {
        dropdown: {
          months: true,
          years: true,
          maxYear: year
        }
      },
      plugins: [AmpPlugin],
    });

    $(el).change(function(event) {
      setTimeout(function() {
        pickers['picker-2-'+index].hide();
      }, 300);
    });
    if($(el).val()) {
      pickers['picker-2-'+index].setDate($(el).val());
      pickers['picker-2-'+index].gotoDate($(el).val());
    }
  });

  $('input.date-time-picker').each(function(index, el) {
    if($(el).hasClass('clear')) {
      $('<a href="#" class="clear">Clear</a>').insertAfter( el ).on('click', function(event) {
        event.preventDefault();
        pickers['time-picker-'+index].clear();
      });
    }
    pickers['time-picker-'+index] = new easepick.create({
      element: el,
      css: [
        'https://cdn.jsdelivr.net/npm/@easepick/bundle@1.2.1/dist/index.css',
        'https://cdn.jsdelivr.net/npm/@easepick/time-plugin@1.2.1/dist/index.css',
        '/css/date-picker.css',
      ],
      format: 'DD/MM/YYYY HH:mm',
      plugins: [TimePlugin, AmpPlugin],
      TimePlugin: {
        format: 'HH:mm',
      },
      AmpPlugin: {
        dropdown: {
          months: true,
          years: true,
          maxYear: year
        }
      },
      zIndex: 999,
      setup(picker) {
        picker.on('select', (e) => {
          $(el).trigger('change');
        });
      },
    });
    if($(el).val()) {
      pickers['time-picker-'+index].setDate($(el).val());
      pickers['time-picker-'+index].gotoDate($(el).val());
    }
  });
}

function remove_pickers() {
  $.each(pickers, function(index, val) {
     val.destroy();
  });
}